export default __webpack_public_path__ + "static/media/arts.74c6496b.svg";